import axios from 'axios';
import { API_ENDPOINTS } from '../config/api';
import { apiClient } from '../config/axiosConfig';
import { OptionType } from '../types/optionTypes';

const api = apiClient;

export async function getProducts() {
  const response = await axios.get(API_ENDPOINTS.products);
  return response.data.map((item: any) => ({
    ...item,
    hasOptions: item.has_options,
    mainCategory: item.main_category,
    imageUrl: item.image_url,
  }));
}

export async function deleteProduct(id: number) {
  await axios.delete(`${API_ENDPOINTS.products}/${id}`);
}

export async function updateProduct(product: any) {
  const response = await axios.put(`${API_ENDPOINTS.products}/${product.id}`, product);
  return response.data;
}

export async function addProduct(product: any) {
  const response = await axios.post(API_ENDPOINTS.products, product);
  return response.data;
}

// Ürünün seçenek türlerini getir
export const getProductOptions = async (productId: number): Promise<OptionType[]> => {
  const response = await api.get(`/api/products/${productId}/options`);
  return response.data;
};
